<template>
  <RevCheckbox
    v-if="offer.compliancy.isUserAgreementRequired"
    :id
    :disabled
    :model-value="offer.compliancy.isUserAgreementAccepted"
    @update:model-value="handleCheck"
  >
    <template #label>
      <div class="leading-[1]">
        <USTerms
          v-if="
            (offer.paymentFrequency === 'ANNUALLY' ||
              offer.paymentFrequency === 'BIANNUALLY' ||
              offer.paymentFrequency === 'MONTHLY') &&
            market.countryCode === 'US'
          "
          :documents="offer.compliancy.documents"
          :insurance-offer="offer"
        />
        <AnnuallyTerms
          v-else-if="offer.paymentFrequency === 'ANNUALLY'"
          :documents="offer.compliancy.documents"
        />
        <Terms v-else :documents="offer.compliancy.documents" />
      </div>
    </template>
  </RevCheckbox>

  <Terms v-else :documents="offer.compliancy.documents" />
</template>

<script setup lang="ts">
import type { InsuranceOffer } from '@backmarket/http-api/src/api-models/InsuranceOffer'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevCheckbox } from '@ds/components/Checkbox'

import AnnuallyTerms from './components/AnnuallyTerms/AnnuallyTerms.vue'
import Terms from './components/Terms/Terms.vue'
import USTerms from './components/USTerms/USTerms.vue'

const { market } = useMarketplace()

const props = defineProps<{
  id: string
  offer: InsuranceOffer
  disabled: boolean
}>()

const emit = defineEmits<{
  update: [updatedInsurance: InsuranceOffer]
}>()

function handleCheck(isUserAgreementAccepted: boolean | string[]) {
  if (typeof isUserAgreementAccepted !== 'boolean') return

  emit('update', {
    ...props.offer,
    compliancy: { ...props.offer.compliancy, isUserAgreementAccepted },
  })
}
</script>
